import React, { FormEvent } from 'react';

import { Button, Label, Modal, Text } from '@auspost/postmaster-react';

import AddressAutosuggest from '../AddressAutosuggest/AddressAutosuggest';
import { INLINE_EDD_CALCULATE_BUTTON_TEST_ID, INLINE_EDD_CANCEL_BUTTON_TEST_ID } from '../InlineEdd.test-ids';
import ManualPostcodeInput from '../ManualPostcodeInput/ManualPostcodeInput';

import styles from '../InlineEdd.module.scss';

export interface SearchResult {
  state?: string;
  suburb?: string;
  postcode: string;
}
export interface AddressLookupModalProps {
  isLoading: boolean;
  handleCancel: () => void;
  handleCalculate: (query: SearchResult) => void;
}

const AddressLookupModal: React.FC<AddressLookupModalProps> = ({ isLoading, handleCancel, handleCalculate }) => {
  const [eddQuery, setEddQuery] = React.useState<SearchResult | null>(null);
  const [isAutoMode, setIsAutoMode] = React.useState(true);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    return eddQuery?.postcode && handleCalculate(eddQuery);
  };

  const displayInputField = () => {
    return !isAutoMode ? (
      <ManualPostcodeInput handleInput={setEddQuery} />
    ) : (
      <AddressAutosuggest
        handleManualMode={() => setIsAutoMode(false)}
        selectOption={(result) => setEddQuery(result)}
      />
    );
  };

  return (
    <>
      <Modal.Header closeButton={false} className={styles.inlineEddModalHeader}>
        <h3 className={styles.inlineEddModalHeading}>Calculate arrival dates</h3>
      </Modal.Header>
      <Modal.Content className={styles.inlineEddModalContentWrapper}>
        <Text variant='body'>Enter the delivery location to find out when this parcel should arrive.</Text>
        <Label htmlFor='addressLookupInput'>Delivering to</Label>
        <form className={styles.inlineEddModalForm} onSubmit={onSubmit} id='addressLookupForm'>
          {displayInputField()}
        </form>
        <Text variant='body-small' weight='medium' className={styles.inlineEddModalContentHeader}>
          Why we’re asking for this
        </Text>
        <Text variant='body-small' className={styles.inlineEddModalContent}>
          <span>The delivery address wasn’t entered into our system this time.</span>
          <span> It’s on the parcel, though – either hand-written or printed on the label.</span>
          <span>So don’t worry, this parcel’s heading to the right place.</span>
        </Text>
      </Modal.Content>
      <Modal.Footer alignment='right'>
        <Button
          size='medium'
          variant='secondary'
          className={styles.inlineEddModalButton}
          onClick={handleCancel}
          type='button'
          data-testid={INLINE_EDD_CANCEL_BUTTON_TEST_ID}
        >
          Cancel
        </Button>
        <Button
          size='medium'
          variant='primary'
          className={styles.inlineEddModalButton}
          isLoading={isLoading}
          type='submit'
          data-testid={INLINE_EDD_CALCULATE_BUTTON_TEST_ID}
          form='addressLookupForm'
        >
          Calculate
        </Button>
      </Modal.Footer>
    </>
  );
};

export default AddressLookupModal;
